import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M98.2 29.24L83.6 1.09998H21.18L3.74 29.24C3.74 29.24 -0.0799818 36.7599 3.57002 44.4299C6.87002 51.3699 13.48 51.5299 13.48 51.5299C13.48 51.5299 18.27 61.27 31.81 57.97C31.81 57.97 39.48 63.88 50.97 63.1C62.46 63.88 70.13 57.97 70.13 57.97C83.67 61.27 88.46 51.5299 88.46 51.5299C88.46 51.5299 95.07 51.3599 98.37 44.4299C102.02 36.7699 98.2 29.24 98.2 29.24Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
